import { render, staticRenderFns } from "./DefaultColors.vue?vue&type=template&id=e53948c2&"
import script from "./DefaultColors.vue?vue&type=script&lang=js&"
export * from "./DefaultColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports